import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { CompetitionMatchEvent } from './competition-match-event'
import { CompetitionMatchEventSerializer } from './competition-match-event.serializer'

@Injectable()
export class CompetitionMatchEventService extends ResourceService<CompetitionMatchEvent> {
  constructor(
    private http: HttpClient,
    private competitionMatchEventSerializer: CompetitionMatchEventSerializer
  ) {
    super(
      http,
      `${environment.backendApiUrl}/competition-match-events`,
      competitionMatchEventSerializer
    )
  }
}
